module.exports = __webpack_public_path__ + "./docs/img/icon-facebook-gray.9c08609ee286a672d119da45901b1e73.svg";